import styled from "styled-components";

export const Container = styled.div`
background-color: ${({theme}) => theme.BACKGROUND1};
width: 100%;
`;